import { createPubSub } from '../state/pubSub/createPubSub'

export const pubSub = {
    MESSAGES: createPubSub('MESSAGES_APP_'),
    PREVIEW: createPubSub('PREVIEW_APP_'),
    MESSAGE: createPubSub('MESSAGE_APP_'),
    SCREEN: createPubSub('SCREEN_APP'),
    HEALTH: createPubSub('HEALTH_APP_'),
    STATE: createPubSub('STATE_APP_'),
    VIDEO: createPubSub('VIDEO_APP_'),
    USERS: createPubSub('USERS_APP'),
    ROOM: createPubSub('ROOM_APP_'),
    MENU: createPubSub('MENU_APP_'),
    GRID: createPubSub('GRID_APP_'),
    MODALS: createPubSub('MODAL_'),
    MODALSTACK: createPubSub('MODALSTACK_'),
}
